
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1ee52cbe&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./default.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./default.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1ee52cbe!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./default.vue"),
  /* scopeId */
  "data-v-1ee52cbe",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/default/default.vue
// module id = 38
// module chunks = 61